export default __webpack_public_path__ + "static/media/SV.9fcea204.svg";